// extracted by mini-css-extract-plugin
module.exports = {"c1dl1h8d":"c1dl1h8d"};